import api from './api';

const create = (data = {}) =>
  api.basic({
    method: api.methods.post,
    url: '/login',
    data: data,
  });

const createDev = (data = {}) =>
  api.basic({
    method: api.methods.post,
    url: '/login_dev',
    data: data,
  });

const refresh = (token = '') =>
  api.basic({
    method: api.methods.post,
    url: '/refresh',
  });

const destroy = () =>
  api.request({
    method: api.methods.get,
    url: '/logout',
  });

const sessionService = {
  create,
  createDev,
  refresh,
  destroy,
};

export default sessionService;
